import React from 'react'
import backgroundSmall from 'assets/images/background-sm.png'
import backgroundLarge from 'assets/images/background-large.png'

function Banner({ title, description, buttonText, buttonLink }) {
  return (
    <section
      id='pagina-inicial'
      className='mt-0 flex max-h-svh w-full items-center justify-center bg-blue text-white md:mt-0'
    >
      <div className='relative flex w-full flex-col items-center gap-8 md:flex-row'>
        <aside className='absolute mt-28 flex flex-col gap-4 p-4 md:w-1/2 md:p-28'>
          <header className='text-4xl font-bold md:text-7xl'>{title}</header>
          <p className='text-xl md:text-2xl'>{description}</p>
          <button className='flex'>
            <a
              href={buttonLink}
              target='_blank'
              rel='noopener noreferrer'
              className='rounded-lg bg-yellow px-6 py-3 font-semibold uppercase text-black transition-opacity duration-500 hover:opacity-75'
            >
              {buttonText}
            </a>
          </button>
        </aside>
        <picture className='w-full'>
          <source media='(min-width: 768px)' srcSet={backgroundLarge} />
          <img src={backgroundSmall} alt='Imagem de fundo' className='w-full object-cover' />
        </picture>
      </div>
    </section>
  )
}

export default Banner
